import * as $options from 'gleam:redraw_toastify/internal/options.ffi'
import { ToastContainer } from 'react-toastify'
import * as runtime from 'react/jsx-runtime'

export function container(props) {
  const props_ = convertProps(props)
  return runtime.jsxs(ToastContainer, props_)
}

// prettier-ignore
function convertProps(options) {
  if (!options) return
  const opts = {}
  $options.addIf(opts, options.position, 'position', $options.convertPosition)
  $options.addIf(opts, options.auto_close, 'autoClose', $options.convertAutoclose)
  $options.addIf(opts, options.close_button, 'closeButton', $options.convertCloseButton)
  $options.addIf(opts, options.transition, 'transition')
  $options.addIf(opts, options.hide_progress_bar, 'hideProgressBar')
  $options.addIf(opts, options.pause_on_hover, 'pauseOnHover')
  $options.addIf(opts, options.pause_on_focus_loss, 'pauseOnFocusLoss')
  $options.addIf(opts, options.rtl, 'rtl')
  $options.addIf(opts, options.stacked, 'stacked')
  $options.addIf(opts, options.close_on_click, 'closeOnClick')
  $options.addIf(opts, options.newest_on_top, 'newestOnTop')
  $options.addIf(opts, options.class_name, 'className')
  $options.addIf(opts, options.style, 'style', $options.convertStyle)
  $options.addIf(opts, options.toast_class_name, 'toastClassName')
  $options.addIf(opts, options.progress_class_name, 'progressClassName')
  $options.addIf(opts, options.draggable, 'draggable')
  $options.addIf(opts, options.draggable_percent, 'draggablePercent')
  $options.addIf(opts, options.draggable_direction, 'draggableDirection', $options.convertDraggableDirection)
  $options.addIf(opts, options.container_id, 'containerId')
  $options.addIf(opts, options.limit, 'limit')
  $options.addIf(opts, options.role, 'role')
  $options.addIf(opts, options.theme, 'theme', $options.convertTheme)
  return opts
}
